import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2084095',
  title: 'Grupo de Sinais e Operações Ao Vivo',
  video: { platform: 'youtube', videoId: 'TLDsqVSjQV0' },
  article: ['Descrição da aula.'],
};
export default lesson;

